import React, { useEffect, useRef } from 'react';
import { Text, View, Platform, StyleSheet, LayoutAnimation } from 'react-native';
import { useNotificationStore } from 'src/domain/stores/useNotificationStore';
import Dimens from 'src/core/utils/Dimens';
import Colors from 'src/core/utils/Colors';

export default function MessageIndicator() {
	const notifications = useNotificationStore((state) => state.notifications);
	const notificationsRead = useNotificationStore((state) => state.notificationsRead);

	const read_count = notifications.length - notificationsRead.length;
	const prevVisibleRef = useRef(read_count >= 1);

	useEffect(() => {
		const isVisible = read_count >= 1;
		if (prevVisibleRef.current !== isVisible) {
			LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
			prevVisibleRef.current = isVisible;
		}
	}, [read_count]);

	if (read_count < 1) return null;

	return (
		<View style={styles.indicator}>
			<Text style={styles.indicatorText}>{read_count}</Text>
		</View>
	);
}

const styles = StyleSheet.create({
	indicator: {
		position: 'absolute',
		top: Platform.OS === 'android' ? 0 : 14,
		zIndex: 10,
		elevation: 3,
		right: Platform.OS === 'android' ? 0 : -10,
		width: Platform.OS === 'android' ? 14 : 20,
		height: Platform.OS === 'android' ? 14 : 20,
		borderRadius: 20,
		backgroundColor: Colors.redAlt,
	},
	indicatorText: {
		lineHeight: Platform.OS === 'android' ? 14 : 20,
		textAlign: 'center',
		color: Colors.white,
		fontSize: Platform.OS === 'android' ? Dimens.fontSize10 : undefined,
	},
});
